import React from 'react';
import "./WeAreYMC.css";
import "../../../GlobalStyle.css"
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpLong } from "@fortawesome/free-solid-svg-icons";
import Francisca from '../../Photos/image 162.png'
import Sabrina from '../../Photos/Sabrina.png'
import PortalButton from '../../Photos/ButtonPortal.png'




function WeAreYMC() {
  const Navigate = useNavigate();

  window.onscroll = function() {
    if(document.URL.includes("quienes-somos")) {
      let tmp = document.getElementById("ToTheTop")
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        tmp.className = tmp.className.replace(" ScrollBackToTopHidden", "");
      } else {
        if(!tmp.className.includes("ScrollBackToTopHidden")) tmp.className += " ScrollBackToTopHidden"
      }
    }
  }

  return (
    <div className="WeAreYMCDiv">
        <div className='WeAreYMCFirstBlockDiv'>
            <div className='WeAreYMCFirstBlockInnerDiv'>
                <div className='WeAreYMCFirstBlockLeft'>
                    <div className='WeAreYMCFirstBlockLeftUpTitle'>Somos yomecontrolo</div>
                    <h1 className='WeAreYMCFirstBlockLeftTitle'>Queremos que la gente viva más y mejor cuidando de su salud preventivamente.</h1>
                    <h5 className='WeAreYMCFirstBlockLeftSubtitle'>Te invitamos a que estes al día con tu salud y acceder así con mayor facilidad a un diagnóstico precoz y un tratamiento oportuno de posibles patologías.</h5>
                </div>
                <div className='WeAreYMCFirstBlockRight'>
                    <img alt="" className="WeAreYMCFirstBlockRightLogo" src='https://static.yomecontrolo.cl/public/img/home/WeAreYMCFirstBlockImage.png'/>
                </div>
            </div>
        </div>
        <div className='WeAreYMCFirstBlockTrustedLogosDiv' style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/home/BackgroundFaintSkyblueOnTheLeft.png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}>

            <div className='WeAreYMCProblemFlex'>
                <div className='WeAreYMCFirstBlockInnerDiv'>
                    <div className='WeAreYMCProblemLeftBlock'>
                        <img alt="" className="WeAreYMCProblemLeftBlockImage" src="https://static.yomecontrolo.cl/public/img/home/WeAreYMCProblemBlock.png"/>
                    </div>
                    <div className='WeAreYMCProblemRightBlock'>
                        <div className='WeAreYMCProblemRightBlockUpTitle'>Existe un problema</div>
                        <h1 className='WeAreYMCProblemRightBlockTitle'>Hay 11 millones de chilenos con enfermedades crónicas y más de la mitad no lo sabe</h1>
                        <h5 className='WeAreYMCProblemRightBlockSubtitle'>El 74% de las muertes son causadas por enfermedades crónicas como la hipertensión, diabetes, cardiopatias, accidentes cerebrovasculares y cáncer.</h5>
        
             <a href="https://salud.yomecontrolo.cl/" style={{ textDecoration: 'none' }}>
            
         <div className='GeneralPurpleButtonFlex PurpleButtonBlock' style={{float:"center"}}>    
        <div className='PurpleButtonText'>
          Ir al portal de Salud +YMC
        </div>
        <div className='PurpleButtonIconPortal'>
          <img src={PortalButton}/>
        </div>
        </div>
        </a>
 </div>
                </div>
            </div>
        </div>
        <div className='WeAreYMCOurMissionFlex'>
            <div className='WeAreYMCFirstBlockInnerDiv'>
                <div className='WeAreYMCOurMissionLeftBlock'>
                    <img alt="" className="WeAreYMCOurMissionLeftBlockImage" src="https://static.yomecontrolo.cl/public/img/home/WeAreYMCSustainableDevelopment.png"/>
                </div>
                <div className='WeAreYMCOurMissionRightBlock'>
                {/*     <div className='WeAreYMCOurMissionRightBlockUpTitle'>Nuestra Misión</div> */}
                    <h1 className='WeAreYMCOurMissionRightBlockTitle'>Encontrar el bienestar presente y futuro de la salud personal / familiar con medicina preventiva a tiempo</h1>
                    <h5 className='WeAreYMCOurMissionRightBlockSubtitle'>Creemos que la tecnología debe estar al servicio de la salud, facilitando diagnósticos oportunos y un tratamiento eficaz.</h5>
                    <div className='WeAreYMCOurMissionRightBlockSmallerSubtitle'>Yo Me Controlo contribuye al ODS 3 impulsando un modelo de salud preventivo, equitativo y basado en datos, que permite a organizaciones y personas acceder a soluciones innovadoras para reducir enfermedades cronicas no transmisibles.
                    </div>
                </div>
            </div>
        </div>

        <div className='WeAreYMCStartupDiv'>
     
            <div className='WeAreYMCStartupFirstBlock'>
                <div className='WeAreYMCFirstBlockInnerDiv WeAreYMCStartupDivTitleFlex'>
                    <h1 className='WeAreYMCStartupTitle'>Un equipo enérgico impulsado por la 
                    <span style={{fontWeight:"800",fontStyle:"italic"}}> promoción de la salud, la innovación y tecnologías digitales.</span></h1>
                    <div className='WeAreYMCStartupSubtitle'>Encontrar el bienestar presente y futuro con medicina preventiva a tiempo</div>
                </div>
                <div className='WeAreYMCStartupTeamImagesFlex'>
                    <div className='WeAreYMCStartupTeamTallImageBlock' id="CEOBlock">
                        <div className='WeAreYMCStartupTeamImageContainer' id="CEO">
                            <img alt="Team member" className="WeAreYMCStartupTeamImage" src="https://static.yomecontrolo.cl/public/img/home/TeamJorgeCTransparent.png"/>
                        </div>
                        <div className="WeAreYMCStartupTeamMemberTexts">
                            <div className="WeAreYMCStartupTeamMemberName">Jorge Caro Díaz</div>
                            <div className="WeAreYMCStartupTeamMemberSpecialty">Médico cirujano<br/>CEO</div>
                        </div>
                    </div>
                    <div className='WeAreYMCStartupTeamShortImageBlock WeAreYMCStartupTeamShortImageBlockReverse' id="Team1">
                        <div className='WeAreYMCStartupTeamImageContainer' id="Team1">
                            <img alt="Team member" className="WeAreYMCStartupTeamImage" src="https://static.yomecontrolo.cl/public/img/home/TeamMacaCTransparent.png"/>
                        </div>
                        <div className="WeAreYMCStartupTeamMemberTexts">
                            <div className="WeAreYMCStartupTeamMemberName">Macarena Castro</div>
                            <div className="WeAreYMCStartupTeamMemberSpecialty">Enfermera<br/>COO</div>
                        </div>
                    </div>
                    <div className='WeAreYMCStartupTeamTallImageBlock' id="Team2">
                        <div className='WeAreYMCStartupTeamImageContainer' id="Team2">
                            <img alt="Team member" className="WeAreYMCStartupTeamImage WeAreYMCStartupTeamImageSlightOffset" style={{objectPosition:"0rem -1vw"}} src="https://static.yomecontrolo.cl/public/img/home/TeamNicoCTransparent.png"/>
                        </div>
                        <div className="WeAreYMCStartupTeamMemberTexts">
                            <div className="WeAreYMCStartupTeamMemberName">Nicolás Cenzano</div>
                            <div className="WeAreYMCStartupTeamMemberSpecialty">Ingeniero Civil en Informática<br/>Máster en IA<br/>CTO</div>
                        </div>
                    </div>
                    <div className='WeAreYMCStartupTeamShortImageBlock WeAreYMCStartupTeamShortImageBlockReverse' id="Team3">
                        <div className='WeAreYMCStartupTeamImageContainer' id="Team3">
                            <img alt="Team member" className="WeAreYMCStartupTeamImage"   style={{padding:'0 36px'}} src={Francisca}/>
                        </div>
                        <div className="WeAreYMCStartupTeamMemberTexts">
                            <div className="WeAreYMCStartupTeamMemberName">Francisca Martinich</div>
                            <div className="WeAreYMCStartupTeamMemberSpecialty"> Ingeniera Civil en Bioingeniería<br/>PhD Sistemas Complejos<br/>CSO </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='WeAreYMCStartupSecondBlock'>
                <div className='WeAreYMCStartupTeamImagesFlex'>
                          <div className='WeAreYMCStartupTeamTallImageBlock' id="Team1">
                        <div className='WeAreYMCStartupTeamImageContainer' id="Team1">
                            <img alt="Team member" className="WeAreYMCStartupTeamImage WeAreYMCStartupTeamImageSlightOffset" src="https://static.yomecontrolo.cl/public/img/home/TeamPaulaCTransparent.png"/>
                        </div>
                        <div className="WeAreYMCStartupTeamMemberTexts">
                            <div className="WeAreYMCStartupTeamMemberName">Paula Cuevas</div>
                            <div className="WeAreYMCStartupTeamMemberSpecialty">Magíster en Bioquímica<br/>Gestión de proyectos</div>
                        </div>
                    </div>

               
                    <div className='WeAreYMCStartupTeamTallImageBlock' id="Team6">
                        <div className='WeAreYMCStartupTeamImageContainer' id="Team6">
                            <img alt="Team member" className="WeAreYMCStartupTeamImage" src="https://static.yomecontrolo.cl/public/img/home/TeamLuisVTransparent.png"/>
                        </div>
                        <div className="WeAreYMCStartupTeamMemberTexts">
                            <div className="WeAreYMCStartupTeamMemberName">Luis H. Vicencio</div>
                            <div className="WeAreYMCStartupTeamMemberSpecialty">Diseñador de branding y UX/UI<br/>Product manager</div>
                        </div>
                    </div>
                    <div className='WeAreYMCStartupTeamShortImageBlock WeAreYMCStartupTeamShortImageBlockReverse' id="Team4">
                        <div className='WeAreYMCStartupTeamImageContainer' id="Team4">
                            <img alt="Team member" className="WeAreYMCStartupTeamImage" src="https://static.yomecontrolo.cl/public/img/home/TeamMaxNTransparent.png"/>
                        </div>
                        <div className="WeAreYMCStartupTeamMemberTexts">
                            <div className="WeAreYMCStartupTeamMemberName">Maximiliano Navarrete</div>
                            <div className="WeAreYMCStartupTeamMemberSpecialty">Ingeniero Civil en Informática<br/>Desarrollador fullstack</div>
                        </div>
                    </div>
                    <div className='WeAreYMCStartupTeamTallImageBlock' id="Team5">
                        <div className='WeAreYMCStartupTeamImageContainer' id="Team5">
                            <img alt="Team member" className="WeAreYMCStartupTeamImage" style={{margin:'auto', marginTop:'35px', width:'85%'}}
                            src={Sabrina}/>
                        </div>
                        <div className="WeAreYMCStartupTeamMemberTexts">
                            <div className="WeAreYMCStartupTeamMemberName">Sabrina Valenzuela</div>
                            <div className="WeAreYMCStartupTeamMemberSpecialty">Nutricionista<br/>Desarrolladora fullstack </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="WeAreYMCOurJourney" style={{ backgroundImage: "url('https://static.yomecontrolo.cl/public/img/home/BackgroundOurJourney.png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}>
                <div className="WeAreYMCOurJourneyUpTitle">Nuestra Trayectoria</div>
                <h2 className="WeAreYMCOurJourneyTitle">Nuestro camino construyendo soluciones digitales para cuidar la salud presente y futura</h2>
                <div className='WeAreYMCOurJourneyEvents'>
                    <h5 className="WeAreYMCOurJourneyYear">2022</h5>
                    <div className="WeAreYMCOurJourneyFlex">
                        <div className="WeAreYMCOurJourneyEventText" id="text-left">Inicio</div>
                        <img className="WeAreYMCOurJourneyIcon" alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/SkyblueRocket.png"/>
                        <h5 className="WeAreYMCOurJourneyDate" id="text-right">Jun. 22</h5>
                    </div>
                    <div className="WeAreYMCOurJourneyFlex">
                        <h5 className="WeAreYMCOurJourneyDate" id="text-left">Nov. 22</h5>
                        <img className="WeAreYMCOurJourneyIcon WeAreYMCOurJourneyIconBigger" alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/SkyblueRocket.png"/>
                        <div className="WeAreYMCOurJourneyEventText" id="text-right">MVP YMC</div>
                    </div>
                    <h4 className="WeAreYMCOurJourneyYear">2023</h4>
                    <div className="WeAreYMCOurJourneyFlex">
                        <div className="WeAreYMCOurJourneyEventText" id="text-left">Inicio Desafío AVANTE 3</div>
                        <img className="WeAreYMCOurJourneyIcon" alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/Avante3.png"/>
                        <h5 className="WeAreYMCOurJourneyDate" id="text-right">Feb. 23</h5>
                    </div>
                    <div className="WeAreYMCOurJourneyFlex">
                        <h5 className="WeAreYMCOurJourneyDate" id="text-left">Mar. 23</h5>
                        <img className="WeAreYMCOurJourneyIcon" alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/StartupChile.png"/>
                        <div className="WeAreYMCOurJourneyEventText" id="text-right">Startup Chile BUILD SUP 5 ($12 mill. Free-equity )</div>
                    </div>
                    <div className="WeAreYMCOurJourneyFlex">
                        <div className="WeAreYMCOurJourneyEventText" id="text-left">Web summit Brasil (Alpha startup programm)</div>
                        <img className="WeAreYMCOurJourneyIcon" alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/WebSummit.png"/>
                        <h5 className="WeAreYMCOurJourneyDate" id="text-right">May. 23</h5>
                    </div>
                    <div className="WeAreYMCOurJourneyFlex">
                        <h5 className="WeAreYMCOurJourneyDate" id="text-left">Jun. 23</h5>
                        <img className="WeAreYMCOurJourneyIcon" alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/Avante3.png"/>
                        <div className="WeAreYMCOurJourneyEventText" id="text-right"> 1° lugar Desafío AVANTE 3, ($45 mill. para co-desarrollo solución (ML) junto a la Armada de Chile)</div>
                    </div>
                    <div className="WeAreYMCOurJourneyFlex">
                        <div className="WeAreYMCOurJourneyEventText" id="text-left">Finalistas Desafío Cáncer (Novartis)</div>
                        <img className="WeAreYMCOurJourneyIcon" alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/Novartis.png"/>
                        <h5 className="WeAreYMCOurJourneyDate" id="text-right">Ago. 23</h5>
                    </div>
                    <div className="WeAreYMCOurJourneyFlex">
                        <h5 className="WeAreYMCOurJourneyDate" id="text-left">Oct. 23</h5>
                        <img className="WeAreYMCOurJourneyIcon" alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/YLAI.png"/>
                        <div className="WeAreYMCOurJourneyEventText" id="text-right">Young leaders of the Americas initiave (COO seleccionada)</div>
                    </div>
                    <h3 className="WeAreYMCOurJourneyYear">2024</h3>
                    <div className="WeAreYMCOurJourneyFlex">
                        <div className="WeAreYMCOurJourneyEventText" id="text-left">ACRUX Modelo predictivo y Priorización (ML)</div>
                        <img className="WeAreYMCOurJourneyIcon" alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/SkyblueExam.png"/>
                        <h5 className="WeAreYMCOurJourneyDate" id="text-right">Feb. 24</h5>
                    </div>
                    <div className="WeAreYMCOurJourneyFlex">
                        <h5 className="WeAreYMCOurJourneyDate" id="text-left">Feb. 24</h5>
                        <img className="WeAreYMCOurJourneyIcon" alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/YMCLogo.png"/>
                        <div className="WeAreYMCOurJourneyEventText" id="text-right">Lanzamiento nueva plataforma YMC</div>
                    </div>
                    <div className="WeAreYMCOurJourneyFlex">
                        <div className="WeAreYMCOurJourneyEventText" id="text-left">Finalistas en la Hackathon</div>
                        <img className="WeAreYMCOurJourneyIcon" alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/Hackaton.png"/>
                        <h5 className="WeAreYMCOurJourneyDate" id="text-right">Ago. 24</h5>
                    </div>
                    <div className="WeAreYMCOurJourneyFlex">
                        <h5 className="WeAreYMCOurJourneyDate" id="text-left">Abr. 25</h5>
                        <img className="WeAreYMCOurJourneyIcon " alt="Icono de evento" src="https://static.yomecontrolo.cl/public/icons/SkyblueRocket.png"/>
                        <div className="WeAreYMCOurJourneyEventText" id="text-right">Adjudicación de los fondos Capital Humano para la innovación de CORFO y Startup Ciencia de ANID</div>
                    </div>
          
                </div>
            </div>
       
        </div>
        
        <div className='ScrollBackToTopOuter ScrollBackToTopHidden' id="ToTheTop">
            <div className='ScrollBackToTop' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
            <FontAwesomeIcon 
                icon={faUpLong} 
                className='ScrollBackToTopUpArrow'
            />
            </div>
        </div>
    </div>
  );
}

export default WeAreYMC;